<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <div class="butonera">
    <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
      <mat-icon class="mat-icon-add-custom">add</mat-icon>
      <app-help key='Socios4'></app-help>
    </button>
  </div>

  <app-table [columns]="headerTable" [dataSource]="dataSource" [hasHeaderActions]="false"
    [headerActionsTemplate]="headerActionsButtons" [hasSelect]="false" [hasButton]="true"
    [actionsTemplate]="actionsButtons">
  </app-table>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container>
      <ul class="custom-class">
        <li (click)="edit(uid)">
          <a>
            <mat-icon>create</mat-icon>Editar
          </a>
        </li>
        <li (click)="delete(uid)">
          <a>
            <mat-icon>warning</mat-icon>Borrar
          </a>
        </li>
        <li (click)="contribution(uid, true)">
          <a>
            <mat-icon>add</mat-icon>Contabilizar Aportación
          </a>
        </li>
        <li (click)="contribution(uid, false)">
          <a>
            <mat-icon>remove</mat-icon>Contabilizar Devolución
          </a>
        </li>
        <li (click)="openRelatedCompaniesT(uid)">
          <a>
            <mat-icon>title</mat-icon> Ver mayor
          </a>
        </li>
      </ul>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/presupuesto.svg" class="invoiceImage" />
      <p style="color: #9e9e9e">
        No tiene ningúna Reserva, presione + para crear una.
      </p>
    </div>
  </ng-container>


</ng-container>
